import localeFr from './fr-FR.json';
import localeEs from './es-ES.json';
import localeIt from './it-IT.json';
import localePt from './pt-PT.json';
export const staticData = {
    'fr-FR:mui': localeFr,
    'es-ES:mui': localeEs,
    'it-IT:mui': localeIt,
    'pt-PT:mui': localePt,
};
